// ProjectItem.jsx
import style from './ProjectItem.module.css';

const pickByLang = (list, lang, field) =>
  list?.find(x => x.language === lang)?.[field] ??
  list?.find(x => x.language === 'en')?.[field] ??
  list?.[0]?.[field] ??
  '';

const ProjectItem = ({ data, lang }) => {
  const title = pickByLang(data.titles, lang, 'title');
  const description = pickByLang(data.descriptions, lang, 'description');

  return (
    <div className={style.gradientContainer}>
      <div className={style.projectItem}>
        <h1>{title}</h1>
        <div className={style.descriptionContainer}>
          <p>{description}</p>
        </div>

        <div className={style.imgContainer}>
          <img src={data.imageUrl} alt={title} loading="lazy" />
        </div>

        <a href={data.websiteUrl} target="_blank" rel="noopener noreferrer">
          <button className={style.website}>To Website</button>
        </a>
      </div>
    </div>
  );
};

export default ProjectItem;
